import React from 'react';
import LockerBoxConfigurator from "../components/iot-devices/locker/box-configurator";

class IotLockerManagerPage extends React.Component {

    render() {
        return (
            <div>
                <LockerBoxConfigurator/>
            </div>
        )
    }
}

export default IotLockerManagerPage;


// WEBPACK FOOTER //
// ./src/containers/iot-locker-manager.js